const TOKEN_KEY = 'jwt_portal-seguranca';

export const login = () => {
    var dadosUsuario = JSON.parse(localStorage.getItem("usuario"));
    localStorage.setItem(TOKEN_KEY, dadosUsuario.accessToken);
}

export const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
}

export const isLogin = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const urlToken = urlParams.get('accessToken');

    if (urlToken) {
        localStorage.setItem(TOKEN_KEY, urlToken);
        return true;
    }

    if (localStorage.getItem(TOKEN_KEY)) {
        return true;
    }
    return false;
}

export const getAccessToken = () => {
    if (localStorage.getItem(TOKEN_KEY)) {
        return localStorage.getItem(TOKEN_KEY);
    } else {
        return {};
    }
}

export const getAuthorizationHeader = () => {
    if (localStorage.getItem(TOKEN_KEY)) {
        return { 'Authorization': getAccessToken() };
    } else {
        return {};
    }
}

export const mapearUrlModulo = (urlOriginal) => {
    if (!urlOriginal) return urlOriginal;

    return urlOriginal;
}

export const clearUrlToken = () => {
    const url = new URL(window.location);
    if (url.searchParams.has('accessToken')) {
        url.searchParams.delete('accessToken');
        window.history.replaceState({}, document.title, url.pathname + url.search);
    }
}